import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    backgroundColor: theme.colorPalette.beige_25,
    width: 580,
    borderRadius: theme.sizes.roundCorners,
    position: 'relative'
  },
  body: {
    padding: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  alertIcon: {
    width: 40,
    height: 34,
    marginBottom: theme.spacing(1)
  },
  title: {
    color: theme.colorPalette.green_75,
    marginBottom: theme.spacing(1)
  },
  intro: {
    color: theme.colorPalette.green_80
  },
  field: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  fieldLabel: {
    color: theme.colorPalette.green_75
  },
  optional: {
    color: theme.colorPalette.green_75,
    textTransform: 'none',
    fontWeight: 400
  },
  buttons: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1)
  },
  button: {
    minWidth: 140
  }
}));

export default useStyles;
